export default (value, palavras) => {
	if (!value) {
		return ''
	}

	palavras.forEach((palavra) => {
		if (palavra) {
			value = value.replace(new RegExp(palavra, 'ig'), (v) => `<span class="cp-destacar-palavra">${v}</span>`)
		}
	})

	return value
}
